import {
  createContext, useContext, useState, useCallback, useEffect,
} from 'react';

import surveyGraphqlService from '@services/api/survey.graphql';
import { USER_ROLES } from '@utils/consts';
import { UserContext } from './User';

export const SurveyAndCheckInsContext = createContext({
  surveyAndCheckInsList: [],
  isLoading: true,
  refetchSurveyAndCheckIns: () => {},
});

const SurveyAndCheckInsProvider = ({ children }) => {
  const { profile } = useContext(UserContext);
  const [surveyAndCheckInsList, setSurveyAndCheckInsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchSurveyAndCheckIns = useCallback(async () => {
    if (!profile || profile.type !== USER_ROLES.STUDENT_ROLE) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const res = await surveyGraphqlService.getSurveyAndCheckIns();
    if (res) {
      setSurveyAndCheckInsList(res);
    }
    setIsLoading(false);
  }, [profile]);

  useEffect(() => {
    fetchSurveyAndCheckIns();
  }, [fetchSurveyAndCheckIns]);

  const value = {
    surveyAndCheckInsList,
    isLoading,
    refetchSurveyAndCheckIns: fetchSurveyAndCheckIns,
  };

  return (
    <SurveyAndCheckInsContext.Provider value={value}>
      {children}
    </SurveyAndCheckInsContext.Provider>
  );
};

export default SurveyAndCheckInsProvider;
